import { Component, Output, EventEmitter, Input, ChangeDetectorRef } from '@angular/core';
import * as req from 'src/app/entities/request';
import * as res from 'src/app/entities/response';
import { BillingManagementService } from 'src/service/billing-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { ActiveInactiveFor, InteractionType, LocalService, Status, TriggeredEvent } from 'src/service/local.service';
import { OfflineService } from 'src/service/offline.service';
import { PrinterService } from 'src/service/printer.service';

@Component({
  selector: 'app-templates',
  templateUrl: './templates.component.html',
  styleUrl: './templates.component.scss'
})
export class TemplatesComponent {
  lstSectionConfigKeys: string[] = ["seller", "printer"];

  InteractionType = InteractionType;
  @Input() ctryCode: string; @Input() businessId: string; @Input() isOfflineServiceAvailable: boolean | null = null;
  maxBodyHeight = 0; isTestPrint = false; billingId: string = '';
  @Output() onPreDataRequired = new EventEmitter();
  @Output() onSaved = new EventEmitter(); @Input() interactionType: InteractionType = InteractionType.None;

  isOpenReceiptTemplatePopup = false;
  isOpenConfirmationBox = false;
  confirmationKey: string = '';

  itemSource: res.PrinterTemplate[] = [];
  items: res.PrinterTemplate[] = [];
  selectedItemId: string | undefined = undefined;
  isIncludeInActive = false;
  searchKey: string = '';

  constructor(public localService: LocalService, private languageManagementService: LanguageManagementService, private printerService: PrinterService, private cdr: ChangeDetectorRef, private billingManagementService: BillingManagementService) { }


  ngOnInit() {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad(isConsiderSave = false) {
    this.onResetLocalPrinters();

    const req = { BusinessId: this.businessId, CountryCode: this.localService.getLoginAsCountryCode(), IsIncludeInActive: this.isIncludeInActive } as req.BusinessDetail;
    this.printerService.getPrinterTemplates(req).subscribe(result => {
      this.itemSource = result;
      this.onFilter();
    });
    if (isConsiderSave) {
      this.onSaved.emit();
    }
  }

  onResetLocalPrinters() {
    this.localService.onTriggerId('on_printer_setup_changed');
  }

  onFilter(isClearSearch = false) {
    if (isClearSearch) {
      this.searchKey = '';
    }
    const key = this.searchKey.trim().toLowerCase();
    const items = key ? this.itemSource.filter(x => x.STitle.includes(key)) : this.itemSource;
    this.items = items;
  }


  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.selectedItemId = undefined;
        this.isOpenReceiptTemplatePopup = true;
      } break;
      case 2: {
        this.selectedItemId = key;
        this.isOpenReceiptTemplatePopup = true;
      } break;
      case 3: {
        //Filter
      } break;
      case 4: {
        //Delete
        this.confirmationKey = key;
        this.isOpenConfirmationBox = true;
      } break;
      case 5: {
        //Restore
        this.onActiveInactiveStatus(key);
      } break;
      case 6: {
        //Delete confirmed
        this.onActiveInactiveStatus(key);
      } break;
      case 7: {
        this.onSetBilingId();
      } break;
    }
  }

  isOpenBillingAdjustmentFormula: boolean = false;
  isOpenFontSettings: boolean = false;
  isReceiptIconConfig: boolean = false;
  onActionBusiness(index: number) {
    switch (index) {
      case 2: {
        //Remove receipt print cache
        this.localService.receiptPrintDatas = [];
        this.billingManagementService.removeReceiptPrintCache(this.businessId).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          if (result.status == Status.Success) {
            this.localService.receiptPrintDatas = [];
            this.localService.onTriggerClass('on_local_printer_changed');
          }
        });
      } break;
      case 3: {
        //Set billing adjustment formula
        this.isOpenBillingAdjustmentFormula = true;
      } break;
      case 4: {
        this.isOpenFontSettings = true;
      } break;
      case 5: {
        this.isReceiptIconConfig = true;
      } break;
    }
  }

  onSetBilingId() {
    this.billingId = '';
    this.billingManagementService.getLatestBillingId(this.businessId).subscribe(result => {
      if (result.status == Status.Success) {
        this.billingId = result.id;
        this.isTestPrint = true;
      } else {
        this.localService.showInformationByStatus(result.status);
      }
    });
  }

  onActiveInactiveStatus(key: string) {
    const req = { BusinessId: this.businessId, CountryCode: this.localService.getLoginAsCountryCode() } as req.BusinessDetail;
    this.printerService.activeInactiveStatus(req, key, ActiveInactiveFor.PrinterTemplate).subscribe(result => {
      if (result && result.status == Status.Success) {
        this.onLoad(true);
      }
      if (result && result.status) {
        this.localService.showInformationByStatus(result.status);
      }
    });
  }


  onDelete(result: any) {
    this.isOpenConfirmationBox = false;
    if (result && result.event == TriggeredEvent.Ok) {
      this.onAction(6, this.confirmationKey);
    }
  }

  ngOnDestroy(): void {
    if (this.interactionType == InteractionType.Bill_PnixSoft) {
      this.onResetLocalPrinters();
    }
  }
}
